module.exports = __webpack_public_path__ + "static/media/calc.019ddde2.svg";